import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService } from '@tcc-mono/shared/data-access';
import { PurchaseInvoice, VionOrder } from '@tcc-mono/vandijk/shared/data-access/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VionOrderService extends BaseService<VionOrder> {
  public constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/vion_orders'
  }

  public downloadPdf = (orderId: number) => {
    return this._http.get(
      `${this.getUrl(this.path)}/${orderId.toString()}/pdf`,
      {
        responseType: 'blob'
      }
    );
  }

  public downloaWeighingSlipdPdf = (orderId: number) => {
    return this._http.get(
      `${this.getUrl(this.path)}/${orderId.toString()}/weighingslippdf`,
      {
        responseType: 'blob'
      }
    );
  }

  public sendEmail = (orderId: number, type: 'invoice' | 'weighing_slip' | 'both'): Observable<unknown> => {
    return this._http.post(`${this.getUrl(this.path)}/${orderId}/send_email`, { type });
  }

  public sendToExact = (id: number): Observable<any> => {
    return this._http.post<any>(`${this.getUrl(this.path)}/${id}/export/exact`, {});
  }

  public finalize = (orderId: number, body: Partial<VionOrder>): Observable<{ data: VionOrder }> => {
    return this._http.post<{ data: VionOrder }>(`${this.getUrl(this.path)}/${orderId}/finalize`, body);
  }

  public createBulkDraftOrders = (): Observable<{
    data: VionOrder[];
    created_count: number;
    skipped_count: number;
  }> => {
    return this._http.post<{
      data: VionOrder[];
      created_count: number;
      skipped_count: number;
    }>(`${this.getUrl(this.path)}/bulk-draft`, {});
  }
}
